module.exports = __webpack_public_path__ + "img/portfolio-big-06.9a5851a8.png";